import request from '@/utils/request';
const path = 'project/report/jrtt';

/**
 * 获取项目转化图表接口
 * @param {Object} data 参数
 * @returns
 */
export function getProjectConvertReportApi(data) {
  return request({
    url: `${path}/convert`,
    method: 'GET',
    params: data,
  });
}

/**
 * 获取项目平台图表接口
 * @param {Object} data 参数
 * @returns
 */

export function getProjectPlatformReportApi(data) {
  return request({
    url: `${path}/platform`,
    method: 'GET',
    params: data,
  });
}

/**
 * 获取项目报表
 * @param {Object} data 参数
 * @returns
 */
export function getProjectTableReportApi(data) {
  return request({
    url: `${path}/table`,
    method: 'GET',
    params: data,
  });
}
